import { useState } from "react";
import { Globe, Copy, Check, ExternalLink, Share2, QrCode } from "lucide-react";
import { toast } from "sonner";
import { PcAccessHintDialog } from "@/components/PcAccessHintDialog";

// Iter 145: link del sito da copiare/aprire nel browser (stesse credenziali dell'app)
export function OpenInBrowserCard() {
  const url = window.location.origin;
  const [copied, setCopied] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    setCopied(true);
    toast.success("Link copiato: incollalo nella barra del browser");
    setTimeout(() => setCopied(false), 2500);
  };

  const share = () => navigator.share({ title: "IL-Report", text: "Entra in IL-Report dal browser con le tue credenziali:", url }).catch(() => {});

  return (
    <div className="rounded-xl border border-slate-200 bg-white px-4 py-3 flex flex-wrap items-center gap-3" data-testid="open-in-browser-card">
      <div className="h-10 w-10 rounded-lg bg-blue-50 text-[#0044FF] grid place-items-center shrink-0">
        <Globe className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-bold text-slate-800">Apri nel browser (PC o tablet)</div>
        <div className="text-xs text-slate-500">Stesso indirizzo, stesse email e password dell'app.</div>
        <a href={url} target="_blank" rel="noopener noreferrer" className="block mt-1 font-mono text-sm text-[#0044FF] underline break-all" data-testid="open-in-browser-url">{url}</a>
      </div>
      <div className="flex items-center gap-2">
        <button type="button" onClick={() => setQrOpen(true)} data-testid="open-in-browser-qr" className="inline-flex items-center gap-1.5 h-10 px-3 rounded-lg border border-slate-300 text-sm font-bold hover:bg-slate-50" title="Mostra QR code da inquadrare con il telefono o il PC">
          <QrCode className="h-4 w-4" /> QR
        </button>
        <PcAccessHintDialog open={qrOpen} onClose={() => setQrOpen(false)} />
        <button type="button" onClick={copy} data-testid="open-in-browser-copy" className="inline-flex items-center gap-1.5 h-10 px-3 rounded-lg border border-slate-300 text-sm font-bold hover:bg-slate-50">
          {copied ? <Check className="h-4 w-4 text-emerald-600" /> : <Copy className="h-4 w-4" />} {copied ? "Copiato" : "Copia link"}
        </button>
        {typeof navigator !== "undefined" && navigator.share && (
          <button type="button" onClick={share} data-testid="open-in-browser-share" className="inline-flex items-center gap-1.5 h-10 px-3 rounded-lg border border-slate-300 text-sm font-bold hover:bg-slate-50" title="Invia il link (es. a te stesso via email o WhatsApp)">
            <Share2 className="h-4 w-4" /> Invia
          </button>
        )}
        <a href={url} target="_blank" rel="noopener noreferrer" data-testid="open-in-browser-open" className="inline-flex items-center gap-1.5 h-10 px-3 rounded-lg bg-[#0044FF] text-white text-sm font-bold hover:bg-[#0033CC]">
          <ExternalLink className="h-4 w-4" /> Apri
        </a>
      </div>
    </div>
  );
}
